import Repository from './Repository';
const UPDATE_DATA = '/menus-lightspeed/updateLocal';
export default {
  syncData(id,menuid) {
    return Repository.get(`${UPDATE_DATA}/${id}/${menuid}`);
  }
};
